export default function Wishlist(){return <div><h1 className="text-2xl font-black">Wishlist</h1><p className="mt-2 text-slate-600">Saved products.</p></div>;}
